<div class="secondary-guest">
  <mat-accordion multi="true" class="secondary-guest-accordian">
    <mat-expansion-panel [expanded]="true" hideToggle>
      <mat-expansion-panel-header>
        <div class="pt-4 mx-2 d-flex flex-row justify-content-between">
          <label class="seat-header-two w-100 rs-pb-10">{{'additionalGuest' | translate}}
            {{secondaryGuestCount}}</label>
          <div class="secondary-guest-delete pe-4"
            (click)="$event.stopPropagation();deleteSecondary(secondaryGuestDetail)">
            <mat-icon matTooltip="{{'Delete' | translate}}">
              <mat-icon>delete</mat-icon>
            </mat-icon>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="secondary-guest-section">
        <dynamic-form  [ngClass]="{'alias-name' : !guestService.widgetSettings?.ShowAliasName}" [config]="secondaryGuestConfig" #form="dynamicForm">
        </dynamic-form>
      </div>
      <div class="notes-section">
        <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<ng-template #notesDisplayContent>
  <ng-container *ngIf="secondaryGuestVisibileFields?.showNotes">
    <ng-container *ngFor="let notes of notesData">
      <div *ngIf="notes.text" class="activity-description-bolder text-uppercase">
        {{notes.text}}
      </div>
      <div class="d-flex flex-row">
        <mat-chip-list selectable multiple>
          <mat-chip class="cursor" #c="matChip" *ngFor="let option of notes.checkBoxOptions"
            [selected]="option.selected" [value]="option.value" (click)="toggleSelection(c, option)">
            <mat-icon class="chip-check-icon" *ngIf="c.selected">check</mat-icon>
            {{option.value}}
          </mat-chip>
        </mat-chip-list>
      </div>
      <div *ngIf="notes.commentsBox?.id" class="pt-3 d-flex flex-row">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{'leaveaComment' | translate}}</mat-label>
          <textarea [(ngModel)]="notes.commentsBox.value" matInput (ngModelChange)="getSecondaryGuestDetails()"
            placeholder="{{'addCommentsHere' | translate}}"></textarea>
        </mat-form-field>
      </div>
    </ng-container>
  </ng-container>
</ng-template>